// -*-mode: rjsx -*-
import React , { useState } from "react"
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';

import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
import ForwardIcon from "@material-ui/icons/ArrowForwardIos"
import grey from "@material-ui/core/colors/grey"

import FlashLogo from "../../static/images/lightning-logo-transparent.png"

const useStyles = makeStyles(theme => ({

    fabDiv: {
        display: "flex",
        justifyContent: "flex-end",
    },
    
    fab: {
        position: "fixed",
        zIndex: 10,
        width: 60,
        height: 60,
        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            // marginTop: "-10%",
            bottom: "5%",
            right: "8%",
        },
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
        },

    },
    
    fabBlue: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    
    "@keyframes loginAnimation":  {
        "0%": {
            opacity: 1,
        },

        "40%": {
            opacity: 1,
        },
        
        "99%": {
            opacity: 0,
            width: "100%",
            height: "100%",
        },

        "100%": {
            opacity: 0,
            width: 0,
            height: 0,
        }
    },

    
    logoRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",
        background: theme.palette.primary.main,
        zIndex: 1000,

        animationName: "$loginAnimation",
        animationDuration: "4s",
        animationFillMode: "forwards",

        userSelect: "none",
        
    },

    logoImg: {

        width: "40%",
        maxWidth: 200,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            // marginTop: -350,
            // marginTop: "-15%",
        },
        
    },

    // text page
    introRoot: {
        position: "fixed",
        top: 0,
        left: 0,
        
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        width: "100%",
        height: "100%",

        backgroundColor: "#FFFFFF",

        userSelect: "none",
        
    },

    introText: {
        margin: "auto",
        marginTop: "18%",
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: "5%",
        },
        paddingLeft: 40,
        paddingRight: 40,
        maxWidth: 600,
        backgroundColor: "#FFFFFF",
        zIndex: 1000
    },

    titleText: {
        color: theme.palette.primary.main,
        fontSize: 21,
    },

    continueText: {
        marginBottom: "0px",
        marginRight: "18px",
        color: theme.palette.primary.main,
        fontSize: "16px",
        fontWeight: "700"
    },
    

    titleLogo: {
        marginRight: 5,
        paddingBottom: 0,
        width: 62,
    },

    forwardArrow_old: {
        marginTop: -20,        
        width: 120,
        height: 120,
        color: theme.palette.primary.main,

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            marginTop: -72,
            marginLeft: -230,        
        },
    },

    forwardButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        //justifyItems: "flex-center",
        width: "51px",
        height: "51px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: "#438cffc2"
        }
    },
    
    forwardArrow: {
        fontSize: "28px",
        color: "white",
        marginLeft: "4px",
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
        },
    }
}))

const LogoFadeout = () => {
    const classes = useStyles()
    return (
        <div className={classes.logoRoot}>
          <img alt="logo" src={FlashLogo} className={classes.logoImg}/>
        </div>
    )
}

/*
  let LogoComponent = withStyles(styles, { name: "LogoComponent" })(
  class LogoComponentBasis extends Component {
  render() {

  const { classes } = this.props
  
  return(
  <div className={classes.logoRoot}>
  <img alt="logo" src={FlashLogo} className={classes.logoImg}/>
  </div>
  )
  }
  }
  )
*/


const InfoBody = ({ info, callbacks }) => {
    
    const classes = useStyles()


    
    return (
        <div className={classes.introRoot}>
          <div className={classes.introText}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
              <div className={classes.titleText}><b>Almost there...</b></div>
              <div className={classes.titleLogo}>
                <img alt="logo" src={FlashLogo} style={{width: "100%"}}/>
              </div>
            </div>
            <div style={{marginTop: 10}}/>
            <div>
              <Typography variant="body1">
                We're are contstanty adding new zip codes and geo locations as more people like you provide us the feedback!
              </Typography>
              <p/>
              <Typography variant="body1">
                Currently, we support zip codes that are in <b>California State Senate District 13</b>
              </Typography>
              <p/>
              {/*
              <Typography variant="body1">
                Right now we zip codes below available, please enter one of those when you register:
              </Typography>
               */}
              <p/>
              {(() => {
                  let index = 0
                  if(!info.validGeos || !info.validGeos.zips) {
                      return (<div/>)
                  }
                  // if we have some valid geos
                  return info.validGeos.zips.map(zip => (<span key={zip.code}>{index++ > 0 ? <i style={{fontSize: "1.2em"}}>, </i> : ""}<b><i style={{fontSize: "1.2em"}}>{zip.code}</i></b></span>))

              })()}
            </div>
            <div style={{marginTop: 15}}/>
            <div>
            </div>
            <div style={{marginTop: 20}}/>
            
            <span onClick={callbacks.onContinue}
                  style={{ cursor: "pointer" }}>

              <div style={{
                  backgroundColor: false ? grey[800] : "inherit",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  //justifyContent: "space-between",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "auto"
              }}>
                <div className={classes.continueText}>REGISTER</div>
                <div className={classes.forwardButton}>
                  <ForwardIcon className={classes.forwardArrow}/>
                </div>                
              </div>
            </span>
          </div>
        </div>
    )
}

const Info = ({history, match}) => {

    const classes = useStyles()
    const [isFirstRender, setIsFirstRender] = useState(true)
    const [info, setInfo] = useState({}) // before we load


    const handleContinueClick = () => {
        console.log("<InfoBody>: handleContinueClick()")
        const { driveSlug } = match.params
        let newUrl = "/register"
        if(driveSlug) {
            newUrl = `/drives/${driveSlug}/register`
        }
        history.push(newUrl)
    }

    if(isFirstRender) {
        console.log("<Info>: first render")
        setIsFirstRender(false)
        setInfo(JSON.parse(localStorage.getItem("info")))
    }

    console.log("<Info>: main: isFirstRender =", isFirstRender)

    return (
        <React.Fragment>
	  <CssBaseline/>
          {/* <LogoFadeout/> */}
          <InfoBody info={info}
                    callbacks={{
                        onContinue: handleContinueClick
                    }}
          />
          BLAH
          {info.text}
        </React.Fragment>
    )
}

export default Info
